import styled from 'styled-components';
import { baseTheme } from '../../../../global/styles/theme';

export const RecipeInfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;

  .recipe-info-block {
    width: 100%;
    height: 100%;
    border: 1px solid ${baseTheme.colors.mainLightBlue};
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .recipe-info {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: flex-start;
      align-content: flex-start;
      .recipe-info-item {
        width: 48%;
        height: fit-content;
        margin: 0;
      }
    }
  }
`;

export const ApplyProductsButton = styled.button`
  cursor: pointer;
  height: 40px;
  width: 48%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: ${baseTheme.colors.mainLightBlue};
  border-radius: 8px;
  border: none;
  font-size: 14px;
  padding: '0px 10px';
  color: ${baseTheme.colors.white};
`;

export const RecipeActiveReceipt = styled('div')`
  padding: 16px;
  display: flex;
  flex-direction: column;
  border: 1px solid ${baseTheme.colors.mainLightBlue};
  height: fit-content;

  .receipts-block {
    .MuiTableContainer-root {
      height: auto;
      max-height: 200px;
      overflow: auto;
    }
  }

  .available-receipts-block {
    height: auto;
    max-height: 200px;
    overflow: auto;
  }

  .active-receipt-top {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .left-block {
      display: flex;
      flex-direction: column;
      gap: 10px;

      .back-to-reciepts {
        display: flex;
        align-items: center;
        gap: 5px;
        width: fit-content;
        cursor: pointer;
        box-shadow: 0px 0px 10px black;
        padding: 5px 10px;
        border-radius: 15px;

        &:hover {
          color: ${baseTheme.colors.mainLightBlue};
          font-size: 14px;
        }

        &: hover img {
          height: 13px;
          width: 13px;
        }

        & img {
          transform: rotate(90deg);
          height: 15px;
          width: 15px;
        }
      }

      .last-update {
        display: flex;
        align-items: center;
        gap: 5px;
      }

      .active-receipt-title {
        font-weight: 500;
        color: ${baseTheme.colors.mainLightBlue};
      }
    }
  }

  .active-receipt-total {
    text-align: right;
    font-weight: 600;
  }

  .active-receipt-error {
    font-weight: 500;
    color: ${baseTheme.colors.error};
    font-size: 18px;
    margin-top: 10px;
  }
`;
